import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useTitular } from '../../../../contexts/InclusaoTitular/context';

import StepProgress from '../../../../components/StepProgress';
import Accordion from '../../../../components/Accordion';
import steps from '../../../../utils/steps.json';
import SearchContainer from '../../../../components/SearchContainer';
import PageLoader from '../../../../components/PageLoader';

import { beneficiarioTitular, getCongenerByContractAndPlanAndUfAndCity } from '../../../../services';
import { getCongenerByContractAndPlan } from '../../../../services/v3/contrato-congenere';

import MensagensAlertas from '../Alertas';

import translate from './translate';

import { getAddress } from '../../../../utils/serviceAddress';

import { useGlobal } from '../../../../contexts/Global/context';
import { PageContainer, ContainerDataTable } from '../../../../styles/styles';
import DataTableMui from '../../../../components/DataTableMui';

function SelecionarTitular() {
    const emptyMessage = 'Não encontramos essa pessoa titular. Você pode fazer uma nova pesquisa.';

    const { dataActiveContract } = useGlobal();

    const { setDataTitular, setFlow } = useTitular();

    const [loading, setLoading] = useState(false);
    const [alreadySearched, setAlreadySearched] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [titulares, setTitulares] = useState([]);
    const [pageLoading, setPageLoading] = useState(false);

    const history = useHistory();

    useEffect(() => {
        setFlow('selecionar_titular');
    }, []);

    async function handleSearch(value) {
        if (!value) return;

        setLoading(true);

        const response = (await beneficiarioTitular(value, dataActiveContract.numero)) || [];

        const translatedResponse = translate(response);

        const dataGrid = translatedResponse.map((element, index) => ({
            index,
            nomeCompleto: element.fullName.value,
            carteirinha: element.cardNumber.value,
            cpf: element.cpf.value,
            tipo: 'Titular',
        }));

        setTitulares(translatedResponse);

        setDataTable(dataGrid);

        setLoading(false);

        setAlreadySearched(true);
    }

    async function handleClickRow(row) {
        const dataTitular = titulares[row.index];

        setPageLoading(true);

        const { nomeMunicipioAtendimento, ufAtendimento, codigoMunicipioAtendimento, dados } = await getAddress(
            dataTitular.cardNumber.value,
            dataActiveContract.numero
        );

        let results;

        if (ufAtendimento && codigoMunicipioAtendimento) {
            results = await getCongenerByContractAndPlanAndUfAndCity({
                numeroContrato: dataActiveContract?.numero,
                codigoPlano: dataTitular?.healthPlan.value,
                siglaUf: ufAtendimento,
                codigoMunicipio: codigoMunicipioAtendimento,
            });
        } else {
            results = await getCongenerByContractAndPlan({
                numeroContrato: dataActiveContract?.numero,
                codigoPlano: dataTitular?.healthPlan.value,
            });
        }

        if (results?.results?.length) results = results.results;

        setDataTitular({
            ...dataTitular,
            stateService: {
                ...dataTitular.stateService,
                lookup: ufAtendimento,
            },
            countyService: {
                ...dataTitular.countyService,
                lookup: nomeMunicipioAtendimento,
            },
            congenerName: {
                ...dataTitular.congenerName,
                value: results ? results[0]?.nomeFantasiaCongenere : '',
            },
            enrollmentSequence: {
                ...dataTitular.enrollmentSequence,
                value: dados?.sequencialMatriculaFuncional,
            },
            functionalEnrollment: {
                ...dataTitular.functionalEnrollment,
                value: dados?.matriculaFuncional,
            },
        });

        setPageLoading(false);

        history.push('/movimentacao_cadastral/adicionar_dependente');
    }

    const rowMutation = {
        click: (row) => {
            handleClickRow(row);
        },
        hasClick: () => true,
    };

    const columnsHead = [
        {
            key: 'numCarteirinha',
            selector: (row) => row.carteirinha || '-',
            name: 'Nº da carteirinha',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'nomeCompleto',
            selector: (row) => row.nomeCompleto || '-',
            name: 'Nome completo',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: 'calc(100% - 600px)', height: '60px' }),
        },
        {
            key: 'cpf',
            selector: (row) => row.cpf || '-',
            name: 'CPF',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '200px' }),
        },
        {
            key: 'tipo',
            selector: (row) => row.tipo,
            name: 'Tipo',
            sortable: true,
            direction: 'center',
            customStyles: () => ({ width: '200px' }),
        },
    ];

    return (
        <>
            <PageContainer>
                <StepProgress steps={steps.inclusaoDependentes} activeStep={1} />

                <MensagensAlertas />

                <Accordion title="Pesquisar titular" hasCollapse={false}>
                    <SearchContainer
                        field={{
                            id: 'searchField',
                            label: 'Digite o nº da carteirinha, nome ou CPF',
                            required: true,
                        }}
                        disabled={loading}
                        onSearch={handleSearch}
                    />
                </Accordion>
            </PageContainer>

            <ContainerDataTable>
                <DataTableMui
                    clickableRow
                    rowMutation={rowMutation}
                    data={dataTable}
                    loading={loading}
                    columns={columnsHead}
                    emptyMessage={emptyMessage}
                    alreadySearched={alreadySearched}
                    firstOrderBy="numCarteirinha"
                />
            </ContainerDataTable>

            <PageLoader loading={pageLoading} />
        </>
    );
}

export default SelecionarTitular;
